import { defineMessages } from 'react-intl';

export const detailSectionMessages = defineMessages({
  collapse: {
    defaultMessage: 'Collapse {title}',
    id: 'b+RGcZ',
    description: 'Accessible label for the button that collapses a detail section',
  },
  expand: {
    defaultMessage: 'Expand {title}',
    id: 'vBTXpv',
    description: 'Accessible label for the button that expands a detail section',
  },
});
